//Libs
import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { persistStore } from "redux-persist";
import { composeWithDevTools } from "redux-devtools-extension";

//Root Reducer
import rootReducer from "./root-reducer";

//Middlewares
const middlewareList = [thunk];

const middlewares = applyMiddleware(...middlewareList);

export const store =
  process.env.NODE_ENV === "production"
    ? createStore(rootReducer, middlewares)
    : createStore(rootReducer, composeWithDevTools(middlewares));

export const persistor = persistStore(store);
